// Shared types + constants for survey projects' custom pre-submit metadata form.
// Mirrors backend/src/models/project.ts (MetadataForm) and the mobile capture
// language list (AppConstants.indianLanguages) so values agree across surfaces.

export type MetadataFormFieldType = 'text' | 'number' | 'dropdown' | 'searchable-dropdown';

export interface MetadataFormField {
  id: string;
  label: string;
  type: MetadataFormFieldType;
  options?: string[];
  required?: boolean;
  default?: string;
  role?: 'language';
}

export interface MetadataForm {
  enabled: boolean;
  fields: MetadataFormField[];
}

// Same focused north-Indian list the mobile capture picker uses. Keep in sync
// with mobile/lib/core/constants/app_constants.dart (indianLanguages + Others).
export const INDIAN_LANGUAGES: string[] = [
  'Hindi',
  'Bhojpuri',
  'Awadhi',
  'Bundeli/Bundelkhandi',
  'Braj Bhasha',
  'Khari Boli (Kauravi)',
  'Urdu',
  'Bhansari',
  'Kannauji',
  'Haryanvi',
  'Others',
];

export const AGE_BUCKETS: string[] = ['10-18', '18-26', '27-33', '34-44', '45-55', '56-65', '65+'];
export const GENDERS: string[] = ['Male', 'Female', 'Other'];

const uid = () =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `f_${Math.random().toString(36).slice(2)}${Date.now()}`;

// The default form seeded when the admin first enables it. Fields are fully
// editable/removable afterwards.
export const defaultMetadataFields = (): MetadataFormField[] => [
  {
    id: uid(),
    label: 'Respondent Language',
    type: 'searchable-dropdown',
    options: [...INDIAN_LANGUAGES],
    required: true,
    default: 'Hindi',
    role: 'language',
  },
  { id: uid(), label: 'Age', type: 'dropdown', options: [...AGE_BUCKETS], required: true },
  { id: uid(), label: 'Gender', type: 'dropdown', options: [...GENDERS], required: true },
];

export const newField = (): MetadataFormField => ({
  id: uid(),
  label: '',
  type: 'text',
  required: false,
});
